import type { PlatformConfig } from '@/types/configs';
import { REGION } from '@/const/env.ts';
import { NINJA_CDN } from '@/const/general';
import { fetchJSON } from '@/utils/fetch';

// The bundler will include only the WEB config file. We need the full typings for the bundler's CLI
let regionConfig: PlatformConfig | undefined = undefined;

export async function loadRegionConfig() {
  if (REGION) {
    const regionConfigUrl = `${NINJA_CDN}/config-${REGION.toLowerCase()}-web.json`;
    regionConfig = await fetchJSON<PlatformConfig>(regionConfigUrl);
  }

  return regionConfig;
}

export function getRegionConfig() {
  return regionConfig;
}
